"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var nav_component_1 = require("./nav.component");
var nav_service_1 = require("./nav.service");
var Nav = angular
    .module("common.nav", [])
    .config(function ($stateProvider) {
    "ngInject";
})
    .service("NavService", nav_service_1.NavService)
    .component("nav", new nav_component_1.NavComponent);
exports.default = Nav;



/** WEBPACK FOOTER **
 ** ./src/app/common/nav/index.ts
 **/